// extracted by mini-css-extract-plugin
module.exports = {"heroSection":"styles_heroSection__v85xF","mainBlockLayout":"styles_mainBlockLayout__161lL","avatarAndCta":"styles_avatarAndCta__W4q9Y"};